import { Actions, createLocalStorageStore, ExtendedAreaModels } from '@bpd-library/utilities';

type CompareStoreAction =
    | 'init'
    | 'compareConstructionNumberAdd'
    | 'compareConstructionNumberRemove'
    | 'setExtendedArea';

export interface CompareState {
    constructionNumberIds: string[];
    data?: ExtendedAreaModels;
}

const initialState: CompareState = {
    constructionNumberIds: [],
};

const actions: Actions<CompareStoreAction, CompareState> = {
    init: (state: CompareState, payload: CompareState) => {
        state.constructionNumberIds = payload.constructionNumberIds;
        return state;
    },
    compareConstructionNumberAdd: (state: CompareState, constructionNumberId: string) => {
        if (!state.constructionNumberIds.includes(constructionNumberId)) {
            state.constructionNumberIds = [...state.constructionNumberIds, constructionNumberId];
        }

        return state;
    },
    compareConstructionNumberRemove: (state: CompareState, constructionNumberId: string) => {
        state.constructionNumberIds = state.constructionNumberIds.filter(
            (id) => id !== constructionNumberId,
        );
        return state;
    },
    setExtendedArea: (state: CompareState, data: ExtendedAreaModels) => {
        state.data = { ...data };
        return state;
    },
};

export const compareStore = createLocalStorageStore({
    key: 'compareHouses',
    initialState,
    actions,
    initAction: 'init',
    expireInDays: 180,
    excludeProps: ['data'],
});

export const compareConstructionNumberAdd = (constructionNumberId: string) => {
    compareStore.dispatch('compareConstructionNumberAdd', constructionNumberId);
};

export const compareConstructionNumberRemove = (constructionNumberId: string) => {
    compareStore.dispatch('compareConstructionNumberRemove', constructionNumberId);
};

export const setCompareData = (data: ExtendedAreaModels) => {
    compareStore.dispatch('setExtendedArea', data);
};

export const getCompareState = () => compareStore.getState();

export const getCompareData = () => compareStore.getState().data;
